const state = {
    picaServiceId: null,
    ordersSummary: null,
    checkinsSummary: null,
    mediaSummary: null,
    engagementSummary: null,
    downloadedMediaIds: null,
}

export const getters = {
    picaServiceId: state => state.picaServiceId,
    ordersSummary: state => state.ordersSummary,
    checkinsSummary: state => state.checkinsSummary,
    mediaSummary: state => state.mediaSummary,
    engagementSummary: state => state.engagementSummary,
    downloadedMediaIds: state => state.downloadedMediaIds,
}


export const mutations = {
    picaServiceId(state, picaServiceId) {
        if (state.picaServiceId === picaServiceId) return
        state.picaServiceId = picaServiceId
        state.ordersSummary = null
        state.checkinsSummary = null
        state.mediaSummary = null
        state.engagementSummary = null
    },
    ordersSummary(state, ordersSummary) {
        state.ordersSummary = ordersSummary
    },
    checkinsSummary(state, checkinsSummary) {
        state.checkinsSummary = checkinsSummary
    },
    mediaSummary(state, mediaSummary) {
        state.mediaSummary = mediaSummary
    },
    engagementSummary(state, engagementSummary) {
        state.engagementSummary = engagementSummary
    },
    downloadedMediaIds(state, downloadedMediaIds) {
        state.downloadedMediaIds = downloadedMediaIds
    },
}


export const actions = service => ({
    setPicaServiceId({commit}, picaServiceId) {
        commit('picaServiceId', picaServiceId)
    },
    async fetchOrdersSummary({commit, getters}) {
        commit('ordersSummary', await service.fetchOrderSummary(getters['picaServiceId']))
    },
    async fetchSummaryCheckins({commit, getters}) {
        commit('checkinsSummary', await service.fetchCheckinsSummary(getters['picaServiceId']))
    },
    async fetchSummaryMedia({commit, getters}) {
        commit('mediaSummary', await service.fetchMediaSummary(getters['picaServiceId']))
    },
    async fetchSummaryEngagement({commit, getters}) {
        commit('engagementSummary', await service.fetchEngagementSummary(getters['picaServiceId']))
    },
    async fetchDownloadedMediaIds({commit}, {picaServiceId, userId}) {
        commit('downloadedMediaIds', await service.fetchDownloadedMediaIds(picaServiceId, userId))
    },
    resetDownloadedMediaIds({commit}) {
        commit('downloadedMediaIds', null)
    },
    updateMediaSummary({commit, getters}, data) {
        // If we don't have existing data, we can't update it
        if (getters['mediaSummary'] === null) return

        // Create a new object with updated values
        const updatedMedia = { ...getters['mediaSummary'] }

        if (data.received != null) updatedMedia.received = data.received
        if (data.delivered != null) updatedMedia.delivered = data.delivered
        if (data.participants != null) updatedMedia.participants = data.participants

        commit('mediaSummary', updatedMedia)
    },
    updateCheckinsSummary({commit, getters}, data) {
        // If we don't have existing data, we can't update it
        if (getters['checkinsSummary'] === null) return

        // Create a new object with updated values
        const updatedCheckins = { ...getters['checkinsSummary'] }

        if (data.total != null) updatedCheckins.total = data.total
        if (data.qrcode != null) updatedCheckins.qrcode = data.qrcode
        if (data.direct != null) updatedCheckins.direct = data.direct

        commit('checkinsSummary', updatedCheckins)
    },
})

export default service => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(service)
})
